import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import WarningIcon from '@material-ui/icons/Warning';
import { CreateCSSProperties } from "@material-ui/core/styles/withStyles";

const useStyles = makeStyles<CreateCSSProperties>(() => ({
  container: {
    paddingBottom: "16px",
    paddingRight: "16px",
    width: "30vw",
  },
  title: {
    "& .MuiTypography-h6": {
      display: "flex",
      alignItems: "center",
      fontSize: "2rem",
    },
  },
  errorMsg: {
    fontSize: "2rem",
    fontWeight: "bold",
  },
  subHeading: {
    fontWeight: 500,
    fontSize: "2rem",
  },
  caption: {
    fontSize: "1.4rem",
    fontWeight: 400,
  },
  marginTop12: {
    marginTop: "12px",
  },
  primaryBtn: {
    background: "#FFAB00",
    color: "#172B4D",
    fontSize: "1.4rem",
  },
}));


const Warning = ({ data }) => {
  const {
    show,
    heading,
    subHeading,
    primaryButtonLabel,
    primaryButtonClick,
    handleClickOnSubheading,
  } = data;
  const classes = useStyles();

  return (
    <Dialog open={show} classes={{ paper: classes.container }} maxWidth="sm">
      <DialogTitle className={classes.title}>
        <WarningIcon
          style={{ marginRight: "12px" }}
          htmlColor="#FFAB00"
          fontSize="medium"
        />
        {heading}
      </DialogTitle>
      <DialogContent>
        {subHeading && (
          <Typography
            variant="h6"
            className={classes.subHeading}
            component="span"
            onClick={(e: any) => {
              if (typeof handleClickOnSubheading === "function") {
                e.stopPropagation();
                handleClickOnSubheading(e.target.id);
              }
            }}
          >
            {subHeading}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          className={classes.primaryBtn}
          onClick={() => {
            if (typeof primaryButtonClick === "function") {
              primaryButtonClick();
            }
          }}
        >
          {primaryButtonLabel || "OK"}
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default Warning;



// WEBPACK FOOTER //
// ./src/editor/ui/editor/imageLibrary/WarningComponent.tsx